import { render, staticRenderFns } from "./SocialRibbonList.vue?vue&type=template&id=f17fb43c&scoped=true"
import script from "./SocialRibbonList.vue?vue&type=script&lang=js"
export * from "./SocialRibbonList.vue?vue&type=script&lang=js"
import style0 from "./SocialRibbonList.vue?vue&type=style&index=0&id=f17fb43c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f17fb43c",
  null
  
)

export default component.exports